/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServiceTypeTemplatesService {
  /**
   * @summary Get All
   * @description Gets all service type templates for the current office.
   */
  getAllServiceTypeTemplatesGet: {
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetParameters,
            TMeta,
            TSignal
          >
        | (QueryFnOptionsByParameters<GetAllServiceTypeTemplatesGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: GetAllServiceTypeTemplatesGetSchema,
        options: {
          parameters: GetAllServiceTypeTemplatesGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetError>>
    ): Promise<RequestFnResponse<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetError>>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    getQueryKey(
      parameters: DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void
    ): ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllServiceTypeTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          GetAllServiceTypeTemplatesGetData,
          GetAllServiceTypeTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetAllServiceTypeTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useQuery()
     * ```
     */
    useQuery<TData = GetAllServiceTypeTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          GetAllServiceTypeTemplatesGetData,
          GetAllServiceTypeTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetAllServiceTypeTemplatesGetError>>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllServiceTypeTemplatesGetParameters,
      TQueryFnData = GetAllServiceTypeTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllServiceTypeTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllServiceTypeTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetAllServiceTypeTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetAllServiceTypeTemplatesGetParameters,
      TQueryFnData = GetAllServiceTypeTemplatesGetData,
      TData = OperationInfiniteData<TQueryFnData, GetAllServiceTypeTemplatesGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetAllServiceTypeTemplatesGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllServiceTypeTemplatesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetAllServiceTypeTemplatesGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getAllServiceTypeTemplatesGetTotal = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useIsFetching()
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getAllServiceTypeTemplatesGetResults = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServiceTypeTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getAllServiceTypeTemplatesGetCombinedResults = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServiceTypeTemplatesGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetAllServiceTypeTemplatesGetSchema,
          GetAllServiceTypeTemplatesGetParameters,
          GetAllServiceTypeTemplatesGetData,
          GetAllServiceTypeTemplatesGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useSuspenseQuery()
     * ```
     */
    useSuspenseQuery<TData = GetAllServiceTypeTemplatesGetData>(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          GetAllServiceTypeTemplatesGetData,
          GetAllServiceTypeTemplatesGetError,
          TData,
          ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetAllServiceTypeTemplatesGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetAllServiceTypeTemplatesGetParameters,
      TData = GetAllServiceTypeTemplatesGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetAllServiceTypeTemplatesGetData,
          GetAllServiceTypeTemplatesGetError,
          OperationInfiniteData<TData, GetAllServiceTypeTemplatesGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetAllServiceTypeTemplatesGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetAllServiceTypeTemplatesGetParameters>,
      OperationError<GetAllServiceTypeTemplatesGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get All
     * @description Gets all service type templates for the current office.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getAllServiceTypeTemplatesGetData = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useSuspenseQueries({
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServiceTypeTemplatesGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getAllServiceTypeTemplatesGetCombinedData = qraft.serviceTypeTemplatesService.getAllServiceTypeTemplatesGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {},
     *         {}
     *     ]
     * });
     * getAllServiceTypeTemplatesGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetAllServiceTypeTemplatesGetSchema,
          GetAllServiceTypeTemplatesGetParameters,
          GetAllServiceTypeTemplatesGetData,
          GetAllServiceTypeTemplatesGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllServiceTypeTemplatesGetSchema,
        GetAllServiceTypeTemplatesGetData,
        GetAllServiceTypeTemplatesGetParameters,
        GetAllServiceTypeTemplatesGetError
      > | void
    ): Promise<GetAllServiceTypeTemplatesGetData>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetAllServiceTypeTemplatesGetSchema,
        GetAllServiceTypeTemplatesGetData,
        GetAllServiceTypeTemplatesGetParameters,
        GetAllServiceTypeTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetAllServiceTypeTemplatesGetSchema,
        GetAllServiceTypeTemplatesGetData,
        GetAllServiceTypeTemplatesGetParameters,
        GetAllServiceTypeTemplatesGetError
      > | void
    ): Promise<GetAllServiceTypeTemplatesGetData>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    fetchInfiniteQuery<TPageParam extends GetAllServiceTypeTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllServiceTypeTemplatesGetSchema,
        GetAllServiceTypeTemplatesGetData,
        GetAllServiceTypeTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceTypeTemplatesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetParameters>>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    prefetchInfiniteQuery<TPageParam extends GetAllServiceTypeTemplatesGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetAllServiceTypeTemplatesGetSchema,
        GetAllServiceTypeTemplatesGetData,
        GetAllServiceTypeTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceTypeTemplatesGetError
      > | void
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    ensureInfiniteQueryData<TPageParam extends GetAllServiceTypeTemplatesGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetAllServiceTypeTemplatesGetSchema,
        GetAllServiceTypeTemplatesGetData,
        GetAllServiceTypeTemplatesGetParameters,
        DeepReadonly<TPageParam>,
        GetAllServiceTypeTemplatesGetError
      > | void
    ): Promise<OperationInfiniteData<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetParameters>>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void)
    ): GetAllServiceTypeTemplatesGetData | undefined;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void)
    ): OperationInfiniteData<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetAllServiceTypeTemplatesGetSchema,
              GetAllServiceTypeTemplatesGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetParameters>
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetAllServiceTypeTemplatesGetSchema,
              GetAllServiceTypeTemplatesGetParameters
            >,
            data: GetAllServiceTypeTemplatesGetData | undefined,
          ]
        >;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | void)
    ): QueryState<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetError> | undefined;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetAllServiceTypeTemplatesGetParameters>
        | ServiceOperationInfiniteQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetParameters>,
          GetAllServiceTypeTemplatesGetError
        >
      | undefined;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    setQueryData(
      parameters:
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | undefined)
        | ServiceOperationQueryKey<GetAllServiceTypeTemplatesGetSchema, GetAllServiceTypeTemplatesGetParameters>,
      updater: Updater<
        NoInfer<GetAllServiceTypeTemplatesGetData> | undefined,
        NoInfer<DeepReadonly<GetAllServiceTypeTemplatesGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetAllServiceTypeTemplatesGetData | undefined;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<GetAllServiceTypeTemplatesGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetParameters
          >,
      updater: Updater<
        | NoInfer<OperationInfiniteData<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetParameters>>
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetParameters>
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetAllServiceTypeTemplatesGetData, GetAllServiceTypeTemplatesGetParameters> | undefined;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >,
      updater: Updater<
        NoInfer<GetAllServiceTypeTemplatesGetData> | undefined,
        NoInfer<GetAllServiceTypeTemplatesGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetAllServiceTypeTemplatesGetData | undefined>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetAllServiceTypeTemplatesGetSchema,
        GetAllServiceTypeTemplatesGetData,
        TInfinite,
        GetAllServiceTypeTemplatesGetParameters,
        GetAllServiceTypeTemplatesGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
    ): void;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get All
     * @description Gets all service type templates for the current office.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
        | QueryFiltersByQueryKey<
            GetAllServiceTypeTemplatesGetSchema,
            GetAllServiceTypeTemplatesGetData,
            TInfinite,
            GetAllServiceTypeTemplatesGetParameters,
            GetAllServiceTypeTemplatesGetError
          >
    ): number;
    schema: GetAllServiceTypeTemplatesGetSchema;
    types: {
      parameters: GetAllServiceTypeTemplatesGetParameters;
      data: GetAllServiceTypeTemplatesGetData;
      error: GetAllServiceTypeTemplatesGetError;
    };
  };
  /**
   * @summary Create
   * @description Creates a new service type template.
   */
  createServiceTypeTemplatesPost: {
    /**
     * @summary Create
     * @description Creates a new service type template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateServiceTypeTemplatesPostBody,
        CreateServiceTypeTemplatesPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateServiceTypeTemplatesPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateServiceTypeTemplatesPostBody,
          CreateServiceTypeTemplatesPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<CreateServiceTypeTemplatesPostData, CreateServiceTypeTemplatesPostError>>
    ): Promise<RequestFnResponse<CreateServiceTypeTemplatesPostData, CreateServiceTypeTemplatesPostError>>;
    /**
     * @summary Create
     * @description Creates a new service type template.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateServiceTypeTemplatesPostParameters> | void
    ): ServiceOperationMutationKey<CreateServiceTypeTemplatesPostSchema, CreateServiceTypeTemplatesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @description Creates a new service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateServiceTypeTemplatesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateServiceTypeTemplatesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceTypeTemplatesPostSchema,
        CreateServiceTypeTemplatesPostData,
        CreateServiceTypeTemplatesPostParameters,
        TVariables,
        OperationError<CreateServiceTypeTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServiceTypeTemplatesPostData,
      OperationError<CreateServiceTypeTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @description Creates a new service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateServiceTypeTemplatesPostBody,
        CreateServiceTypeTemplatesPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateServiceTypeTemplatesPostSchema,
        CreateServiceTypeTemplatesPostData,
        CreateServiceTypeTemplatesPostParameters,
        TVariables,
        OperationError<CreateServiceTypeTemplatesPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServiceTypeTemplatesPostData,
      OperationError<CreateServiceTypeTemplatesPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @description Creates a new service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createServiceTypeTemplatesPostTotal = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createServiceTypeTemplatesPostTotal = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceTypeTemplatesPostBody,
            CreateServiceTypeTemplatesPostData,
            CreateServiceTypeTemplatesPostParameters,
            OperationError<CreateServiceTypeTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceTypeTemplatesPostSchema,
            CreateServiceTypeTemplatesPostBody,
            CreateServiceTypeTemplatesPostData,
            CreateServiceTypeTemplatesPostParameters,
            OperationError<CreateServiceTypeTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @description Creates a new service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createServiceTypeTemplatesPostPendingMutationVariables = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createServiceTypeTemplatesPostMutationData = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateServiceTypeTemplatesPostData,
        OperationError<CreateServiceTypeTemplatesPostError>,
        MutationVariables<CreateServiceTypeTemplatesPostBody, CreateServiceTypeTemplatesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateServiceTypeTemplatesPostBody,
            CreateServiceTypeTemplatesPostData,
            CreateServiceTypeTemplatesPostParameters,
            OperationError<CreateServiceTypeTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceTypeTemplatesPostSchema,
            CreateServiceTypeTemplatesPostBody,
            CreateServiceTypeTemplatesPostData,
            CreateServiceTypeTemplatesPostParameters,
            OperationError<CreateServiceTypeTemplatesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateServiceTypeTemplatesPostData,
          OperationError<CreateServiceTypeTemplatesPostError>,
          MutationVariables<CreateServiceTypeTemplatesPostBody, CreateServiceTypeTemplatesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create
     * @description Creates a new service type template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateServiceTypeTemplatesPostBody,
            CreateServiceTypeTemplatesPostData,
            CreateServiceTypeTemplatesPostParameters,
            OperationError<CreateServiceTypeTemplatesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServiceTypeTemplatesPostSchema,
            CreateServiceTypeTemplatesPostBody,
            CreateServiceTypeTemplatesPostData,
            CreateServiceTypeTemplatesPostParameters,
            OperationError<CreateServiceTypeTemplatesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @description Creates a new service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceTypeTemplatesService.createServiceTypeTemplatesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateServiceTypeTemplatesPostBody,
              CreateServiceTypeTemplatesPostData,
              CreateServiceTypeTemplatesPostParameters,
              OperationError<CreateServiceTypeTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceTypeTemplatesPostSchema,
              CreateServiceTypeTemplatesPostBody,
              CreateServiceTypeTemplatesPostData,
              CreateServiceTypeTemplatesPostParameters,
              OperationError<CreateServiceTypeTemplatesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateServiceTypeTemplatesPostData,
            CreateServiceTypeTemplatesPostError,
            MutationVariables<CreateServiceTypeTemplatesPostBody, CreateServiceTypeTemplatesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateServiceTypeTemplatesPostBody,
              CreateServiceTypeTemplatesPostData,
              CreateServiceTypeTemplatesPostParameters,
              OperationError<CreateServiceTypeTemplatesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServiceTypeTemplatesPostSchema,
              CreateServiceTypeTemplatesPostBody,
              CreateServiceTypeTemplatesPostData,
              CreateServiceTypeTemplatesPostParameters,
              OperationError<CreateServiceTypeTemplatesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateServiceTypeTemplatesPostData,
          CreateServiceTypeTemplatesPostError,
          MutationVariables<CreateServiceTypeTemplatesPostBody, CreateServiceTypeTemplatesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateServiceTypeTemplatesPostSchema;
    types: {
      parameters: CreateServiceTypeTemplatesPostParameters;
      data: CreateServiceTypeTemplatesPostData;
      error: CreateServiceTypeTemplatesPostError;
      body: CreateServiceTypeTemplatesPostBody;
    };
  };
  /**
   * @summary Get
   * @description Gets a service type template by ID.
   */
  getServiceTypeTemplatesTemplateIdGet: {
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            TMeta,
            TSignal
          >
        | QueryFnOptionsByParameters<GetServiceTypeTemplatesTemplateIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetServiceTypeTemplatesTemplateIdGetSchema,
        options: {
          parameters: GetServiceTypeTemplatesTemplateIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<
        RequestFnResponse<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetError>
      >
    ): Promise<RequestFnResponse<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetError>>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    getQueryKey(
      parameters: DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>
    ): ServiceOperationQueryKey<
      GetServiceTypeTemplatesTemplateIdGetSchema,
      GetServiceTypeTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetServiceTypeTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetServiceTypeTemplatesTemplateIdGetData,
          GetServiceTypeTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetServiceTypeTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetServiceTypeTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetServiceTypeTemplatesTemplateIdGetData,
          GetServiceTypeTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetServiceTypeTemplatesTemplateIdGetError>>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<
      GetServiceTypeTemplatesTemplateIdGetSchema,
      GetServiceTypeTemplatesTemplateIdGetParameters
    >;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetServiceTypeTemplatesTemplateIdGetParameters,
      TQueryFnData = GetServiceTypeTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetServiceTypeTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetServiceTypeTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetServiceTypeTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetServiceTypeTemplatesTemplateIdGetParameters,
      TQueryFnData = GetServiceTypeTemplatesTemplateIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetServiceTypeTemplatesTemplateIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetServiceTypeTemplatesTemplateIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetServiceTypeTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetServiceTypeTemplatesTemplateIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getServiceTypeTemplatesTemplateIdGetTotal = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getServiceTypeTemplatesTemplateIdGetByParametersTotal = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getServiceTypeTemplatesTemplateIdGetResults = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getServiceTypeTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getServiceTypeTemplatesTemplateIdGetCombinedResults = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getServiceTypeTemplatesTemplateIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetServiceTypeTemplatesTemplateIdGetSchema,
          GetServiceTypeTemplatesTemplateIdGetParameters,
          GetServiceTypeTemplatesTemplateIdGetData,
          GetServiceTypeTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseQueryResult<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          UseQueryResult<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetError>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useSuspenseQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetServiceTypeTemplatesTemplateIdGetData>(
      parameters:
        | ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetServiceTypeTemplatesTemplateIdGetData,
          GetServiceTypeTemplatesTemplateIdGetError,
          TData,
          ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetServiceTypeTemplatesTemplateIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         template_id: templateId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<
      TPageParam extends GetServiceTypeTemplatesTemplateIdGetParameters,
      TData = GetServiceTypeTemplatesTemplateIdGetData,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetServiceTypeTemplatesTemplateIdGetData,
          GetServiceTypeTemplatesTemplateIdGetError,
          OperationInfiniteData<TData, GetServiceTypeTemplatesTemplateIdGetParameters>,
          ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<
          GetServiceTypeTemplatesTemplateIdGetData,
          PartialParameters<DeepReadonly<TPageParam>>
        >
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetServiceTypeTemplatesTemplateIdGetParameters>,
      OperationError<GetServiceTypeTemplatesTemplateIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @description Gets a service type template by ID.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getServiceTypeTemplatesTemplateIdGetData = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getServiceTypeTemplatesTemplateIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getServiceTypeTemplatesTemplateIdGetCombinedData = qraft.serviceTypeTemplatesService.getServiceTypeTemplatesTemplateIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 template_id: templateId1
     *             }
     *         },
     *         {
     *             path: {
     *                 template_id: templateId2
     *             }
     *         }
     *     ]
     * });
     * getServiceTypeTemplatesTemplateIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetServiceTypeTemplatesTemplateIdGetSchema,
          GetServiceTypeTemplatesTemplateIdGetParameters,
          GetServiceTypeTemplatesTemplateIdGetData,
          GetServiceTypeTemplatesTemplateIdGetError
        >
      >,
      TCombinedResult = Array<
        UseSuspenseQueryResult<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetError>
      >,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<
            UseSuspenseQueryResult<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetError>,
            'data'
          >
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetServiceTypeTemplatesTemplateIdGetSchema,
        GetServiceTypeTemplatesTemplateIdGetData,
        GetServiceTypeTemplatesTemplateIdGetParameters,
        GetServiceTypeTemplatesTemplateIdGetError
      >
    ): Promise<GetServiceTypeTemplatesTemplateIdGetData>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetServiceTypeTemplatesTemplateIdGetSchema,
        GetServiceTypeTemplatesTemplateIdGetData,
        GetServiceTypeTemplatesTemplateIdGetParameters,
        GetServiceTypeTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetServiceTypeTemplatesTemplateIdGetSchema,
        GetServiceTypeTemplatesTemplateIdGetData,
        GetServiceTypeTemplatesTemplateIdGetParameters,
        GetServiceTypeTemplatesTemplateIdGetError
      >
    ): Promise<GetServiceTypeTemplatesTemplateIdGetData>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    fetchInfiniteQuery<TPageParam extends GetServiceTypeTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetServiceTypeTemplatesTemplateIdGetSchema,
        GetServiceTypeTemplatesTemplateIdGetData,
        GetServiceTypeTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetServiceTypeTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetParameters>
    >;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    prefetchInfiniteQuery<TPageParam extends GetServiceTypeTemplatesTemplateIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetServiceTypeTemplatesTemplateIdGetSchema,
        GetServiceTypeTemplatesTemplateIdGetData,
        GetServiceTypeTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetServiceTypeTemplatesTemplateIdGetError
      >
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    ensureInfiniteQueryData<TPageParam extends GetServiceTypeTemplatesTemplateIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetServiceTypeTemplatesTemplateIdGetSchema,
        GetServiceTypeTemplatesTemplateIdGetData,
        GetServiceTypeTemplatesTemplateIdGetParameters,
        DeepReadonly<TPageParam>,
        GetServiceTypeTemplatesTemplateIdGetError
      >
    ): Promise<
      OperationInfiniteData<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetParameters>
    >;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>
    ): GetServiceTypeTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>
    ):
      | OperationInfiniteData<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetParameters>
      | undefined;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<
              GetServiceTypeTemplatesTemplateIdGetSchema,
              GetServiceTypeTemplatesTemplateIdGetParameters
            >,
            data:
              | NoInfer<
                  OperationInfiniteData<
                    GetServiceTypeTemplatesTemplateIdGetData,
                    GetServiceTypeTemplatesTemplateIdGetParameters
                  >
                >
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<
              GetServiceTypeTemplatesTemplateIdGetSchema,
              GetServiceTypeTemplatesTemplateIdGetParameters
            >,
            data: GetServiceTypeTemplatesTemplateIdGetData | undefined,
          ]
        >;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>
    ): QueryState<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetError> | undefined;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >
    ):
      | QueryState<
          OperationInfiniteData<
            GetServiceTypeTemplatesTemplateIdGetData,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >,
          GetServiceTypeTemplatesTemplateIdGetError
        >
      | undefined;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    setQueryData(
      parameters:
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>
        | ServiceOperationQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        NoInfer<GetServiceTypeTemplatesTemplateIdGetData> | undefined,
        NoInfer<DeepReadonly<GetServiceTypeTemplatesTemplateIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetServiceTypeTemplatesTemplateIdGetData | undefined;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetServiceTypeTemplatesTemplateIdGetParameters>
        | ServiceOperationInfiniteQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetParameters
          >,
      updater: Updater<
        | NoInfer<
            OperationInfiniteData<
              GetServiceTypeTemplatesTemplateIdGetData,
              GetServiceTypeTemplatesTemplateIdGetParameters
            >
          >
        | undefined,
        | NoInfer<
            DeepReadonly<
              OperationInfiniteData<
                GetServiceTypeTemplatesTemplateIdGetData,
                GetServiceTypeTemplatesTemplateIdGetParameters
              >
            >
          >
        | undefined
      >,
      options?: SetDataOptions
    ):
      | OperationInfiniteData<GetServiceTypeTemplatesTemplateIdGetData, GetServiceTypeTemplatesTemplateIdGetParameters>
      | undefined;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >,
      updater: Updater<
        NoInfer<GetServiceTypeTemplatesTemplateIdGetData> | undefined,
        NoInfer<GetServiceTypeTemplatesTemplateIdGetData> | undefined
      >,
      options?: SetDataOptions
    ): Array<GetServiceTypeTemplatesTemplateIdGetData | undefined>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetServiceTypeTemplatesTemplateIdGetSchema,
        GetServiceTypeTemplatesTemplateIdGetData,
        TInfinite,
        GetServiceTypeTemplatesTemplateIdGetParameters,
        GetServiceTypeTemplatesTemplateIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
    ): void;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /**
     * @summary Get
     * @description Gets a service type template by ID.
     */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
        | QueryFiltersByQueryKey<
            GetServiceTypeTemplatesTemplateIdGetSchema,
            GetServiceTypeTemplatesTemplateIdGetData,
            TInfinite,
            GetServiceTypeTemplatesTemplateIdGetParameters,
            GetServiceTypeTemplatesTemplateIdGetError
          >
    ): number;
    schema: GetServiceTypeTemplatesTemplateIdGetSchema;
    types: {
      parameters: GetServiceTypeTemplatesTemplateIdGetParameters;
      data: GetServiceTypeTemplatesTemplateIdGetData;
      error: GetServiceTypeTemplatesTemplateIdGetError;
    };
  };
  /**
   * @summary Update
   * @description Updates an existing service type template.
   */
  updateServiceTypeTemplatesTemplateIdPatch: {
    /**
     * @summary Update
     * @description Updates an existing service type template.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateServiceTypeTemplatesTemplateIdPatchBody,
        UpdateServiceTypeTemplatesTemplateIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateServiceTypeTemplatesTemplateIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateServiceTypeTemplatesTemplateIdPatchBody,
          UpdateServiceTypeTemplatesTemplateIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<UpdateServiceTypeTemplatesTemplateIdPatchData, UpdateServiceTypeTemplatesTemplateIdPatchError>
      >
    ): Promise<
      RequestFnResponse<UpdateServiceTypeTemplatesTemplateIdPatchData, UpdateServiceTypeTemplatesTemplateIdPatchError>
    >;
    /**
     * @summary Update
     * @description Updates an existing service type template.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateServiceTypeTemplatesTemplateIdPatchParameters> | void
    ): ServiceOperationMutationKey<
      UpdateServiceTypeTemplatesTemplateIdPatchSchema,
      UpdateServiceTypeTemplatesTemplateIdPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Updates an existing service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateServiceTypeTemplatesTemplateIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateServiceTypeTemplatesTemplateIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceTypeTemplatesTemplateIdPatchSchema,
        UpdateServiceTypeTemplatesTemplateIdPatchData,
        UpdateServiceTypeTemplatesTemplateIdPatchParameters,
        TVariables,
        OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServiceTypeTemplatesTemplateIdPatchData,
      OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @description Updates an existing service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.useMutation({
     *     path: {
     *         template_id: templateId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         template_id: templateId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateServiceTypeTemplatesTemplateIdPatchBody,
        UpdateServiceTypeTemplatesTemplateIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateServiceTypeTemplatesTemplateIdPatchSchema,
        UpdateServiceTypeTemplatesTemplateIdPatchData,
        UpdateServiceTypeTemplatesTemplateIdPatchParameters,
        TVariables,
        OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServiceTypeTemplatesTemplateIdPatchData,
      OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @description Updates an existing service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateServiceTypeTemplatesTemplateIdPatchTotal = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateServiceTypeTemplatesTemplateIdPatchTotal = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTypeTemplatesTemplateIdPatchBody,
            UpdateServiceTypeTemplatesTemplateIdPatchData,
            UpdateServiceTypeTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTypeTemplatesTemplateIdPatchSchema,
            UpdateServiceTypeTemplatesTemplateIdPatchBody,
            UpdateServiceTypeTemplatesTemplateIdPatchData,
            UpdateServiceTypeTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @description Updates an existing service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateServiceTypeTemplatesTemplateIdPatchPendingMutationVariables = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateServiceTypeTemplatesTemplateIdPatchMutationData = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 template_id: templateId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateServiceTypeTemplatesTemplateIdPatchData,
        OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
        MutationVariables<
          UpdateServiceTypeTemplatesTemplateIdPatchBody,
          UpdateServiceTypeTemplatesTemplateIdPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTypeTemplatesTemplateIdPatchBody,
            UpdateServiceTypeTemplatesTemplateIdPatchData,
            UpdateServiceTypeTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTypeTemplatesTemplateIdPatchSchema,
            UpdateServiceTypeTemplatesTemplateIdPatchBody,
            UpdateServiceTypeTemplatesTemplateIdPatchData,
            UpdateServiceTypeTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateServiceTypeTemplatesTemplateIdPatchData,
          OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
          MutationVariables<
            UpdateServiceTypeTemplatesTemplateIdPatchBody,
            UpdateServiceTypeTemplatesTemplateIdPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update
     * @description Updates an existing service type template.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServiceTypeTemplatesTemplateIdPatchBody,
            UpdateServiceTypeTemplatesTemplateIdPatchData,
            UpdateServiceTypeTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServiceTypeTemplatesTemplateIdPatchSchema,
            UpdateServiceTypeTemplatesTemplateIdPatchBody,
            UpdateServiceTypeTemplatesTemplateIdPatchData,
            UpdateServiceTypeTemplatesTemplateIdPatchParameters,
            OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @description Updates an existing service type template.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             template_id: templateId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceTypeTemplatesService.updateServiceTypeTemplatesTemplateIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateServiceTypeTemplatesTemplateIdPatchBody,
              UpdateServiceTypeTemplatesTemplateIdPatchData,
              UpdateServiceTypeTemplatesTemplateIdPatchParameters,
              OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceTypeTemplatesTemplateIdPatchSchema,
              UpdateServiceTypeTemplatesTemplateIdPatchBody,
              UpdateServiceTypeTemplatesTemplateIdPatchData,
              UpdateServiceTypeTemplatesTemplateIdPatchParameters,
              OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateServiceTypeTemplatesTemplateIdPatchData,
            UpdateServiceTypeTemplatesTemplateIdPatchError,
            MutationVariables<
              UpdateServiceTypeTemplatesTemplateIdPatchBody,
              UpdateServiceTypeTemplatesTemplateIdPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateServiceTypeTemplatesTemplateIdPatchBody,
              UpdateServiceTypeTemplatesTemplateIdPatchData,
              UpdateServiceTypeTemplatesTemplateIdPatchParameters,
              OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServiceTypeTemplatesTemplateIdPatchSchema,
              UpdateServiceTypeTemplatesTemplateIdPatchBody,
              UpdateServiceTypeTemplatesTemplateIdPatchData,
              UpdateServiceTypeTemplatesTemplateIdPatchParameters,
              OperationError<UpdateServiceTypeTemplatesTemplateIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateServiceTypeTemplatesTemplateIdPatchData,
          UpdateServiceTypeTemplatesTemplateIdPatchError,
          MutationVariables<
            UpdateServiceTypeTemplatesTemplateIdPatchBody,
            UpdateServiceTypeTemplatesTemplateIdPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateServiceTypeTemplatesTemplateIdPatchSchema;
    types: {
      parameters: UpdateServiceTypeTemplatesTemplateIdPatchParameters;
      data: UpdateServiceTypeTemplatesTemplateIdPatchData;
      error: UpdateServiceTypeTemplatesTemplateIdPatchError;
      body: UpdateServiceTypeTemplatesTemplateIdPatchBody;
    };
  };
  /**
   * @summary Batch Update Service Type Templates
   * @description Batch updates multiple service type templates.
   */
  batchUpdateServiceTypeTemplates: {
    /**
     * @summary Batch Update Service Type Templates
     * @description Batch updates multiple service type templates.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        BatchUpdateServiceTypeTemplatesBody,
        BatchUpdateServiceTypeTemplatesParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: BatchUpdateServiceTypeTemplatesSchema,
        options: ServiceOperationMutationFnOptions<
          BatchUpdateServiceTypeTemplatesBody,
          BatchUpdateServiceTypeTemplatesParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<BatchUpdateServiceTypeTemplatesData, BatchUpdateServiceTypeTemplatesError>>
    ): Promise<RequestFnResponse<BatchUpdateServiceTypeTemplatesData, BatchUpdateServiceTypeTemplatesError>>;
    /**
     * @summary Batch Update Service Type Templates
     * @description Batch updates multiple service type templates.
     */
    getMutationKey(
      parameters: DeepReadonly<BatchUpdateServiceTypeTemplatesParameters> | void
    ): ServiceOperationMutationKey<BatchUpdateServiceTypeTemplatesSchema, BatchUpdateServiceTypeTemplatesParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Update Service Type Templates
     * @description Batch updates multiple service type templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends BatchUpdateServiceTypeTemplatesBody, TContext = unknown>(
      parameters: DeepReadonly<BatchUpdateServiceTypeTemplatesParameters>,
      options?: ServiceOperationUseMutationOptions<
        BatchUpdateServiceTypeTemplatesSchema,
        BatchUpdateServiceTypeTemplatesData,
        BatchUpdateServiceTypeTemplatesParameters,
        TVariables,
        OperationError<BatchUpdateServiceTypeTemplatesError>,
        TContext
      >
    ): UseMutationResult<
      BatchUpdateServiceTypeTemplatesData,
      OperationError<BatchUpdateServiceTypeTemplatesError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Batch Update Service Type Templates
     * @description Batch updates multiple service type templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        BatchUpdateServiceTypeTemplatesBody,
        BatchUpdateServiceTypeTemplatesParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        BatchUpdateServiceTypeTemplatesSchema,
        BatchUpdateServiceTypeTemplatesData,
        BatchUpdateServiceTypeTemplatesParameters,
        TVariables,
        OperationError<BatchUpdateServiceTypeTemplatesError>,
        TContext
      >
    ): UseMutationResult<
      BatchUpdateServiceTypeTemplatesData,
      OperationError<BatchUpdateServiceTypeTemplatesError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Batch Update Service Type Templates
     * @description Batch updates multiple service type templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const batchUpdateServiceTypeTemplatesTotal = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const batchUpdateServiceTypeTemplatesTotal = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateServiceTypeTemplatesBody,
            BatchUpdateServiceTypeTemplatesData,
            BatchUpdateServiceTypeTemplatesParameters,
            OperationError<BatchUpdateServiceTypeTemplatesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateServiceTypeTemplatesSchema,
            BatchUpdateServiceTypeTemplatesBody,
            BatchUpdateServiceTypeTemplatesData,
            BatchUpdateServiceTypeTemplatesParameters,
            OperationError<BatchUpdateServiceTypeTemplatesError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Batch Update Service Type Templates
     * @description Batch updates multiple service type templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const batchUpdateServiceTypeTemplatesPendingMutationVariables = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const batchUpdateServiceTypeTemplatesMutationData = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        BatchUpdateServiceTypeTemplatesData,
        OperationError<BatchUpdateServiceTypeTemplatesError>,
        MutationVariables<BatchUpdateServiceTypeTemplatesBody, BatchUpdateServiceTypeTemplatesParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateServiceTypeTemplatesBody,
            BatchUpdateServiceTypeTemplatesData,
            BatchUpdateServiceTypeTemplatesParameters,
            OperationError<BatchUpdateServiceTypeTemplatesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateServiceTypeTemplatesSchema,
            BatchUpdateServiceTypeTemplatesBody,
            BatchUpdateServiceTypeTemplatesData,
            BatchUpdateServiceTypeTemplatesParameters,
            OperationError<BatchUpdateServiceTypeTemplatesError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          BatchUpdateServiceTypeTemplatesData,
          OperationError<BatchUpdateServiceTypeTemplatesError>,
          MutationVariables<BatchUpdateServiceTypeTemplatesBody, BatchUpdateServiceTypeTemplatesParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Batch Update Service Type Templates
     * @description Batch updates multiple service type templates.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            BatchUpdateServiceTypeTemplatesBody,
            BatchUpdateServiceTypeTemplatesData,
            BatchUpdateServiceTypeTemplatesParameters,
            OperationError<BatchUpdateServiceTypeTemplatesError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            BatchUpdateServiceTypeTemplatesSchema,
            BatchUpdateServiceTypeTemplatesBody,
            BatchUpdateServiceTypeTemplatesData,
            BatchUpdateServiceTypeTemplatesParameters,
            OperationError<BatchUpdateServiceTypeTemplatesError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Batch Update Service Type Templates
     * @description Batch updates multiple service type templates.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.serviceTypeTemplatesService.batchUpdateServiceTypeTemplates.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              BatchUpdateServiceTypeTemplatesBody,
              BatchUpdateServiceTypeTemplatesData,
              BatchUpdateServiceTypeTemplatesParameters,
              OperationError<BatchUpdateServiceTypeTemplatesError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchUpdateServiceTypeTemplatesSchema,
              BatchUpdateServiceTypeTemplatesBody,
              BatchUpdateServiceTypeTemplatesData,
              BatchUpdateServiceTypeTemplatesParameters,
              OperationError<BatchUpdateServiceTypeTemplatesError>,
              TContext
            >
      ):
        | Mutation<
            BatchUpdateServiceTypeTemplatesData,
            BatchUpdateServiceTypeTemplatesError,
            MutationVariables<BatchUpdateServiceTypeTemplatesBody, BatchUpdateServiceTypeTemplatesParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              BatchUpdateServiceTypeTemplatesBody,
              BatchUpdateServiceTypeTemplatesData,
              BatchUpdateServiceTypeTemplatesParameters,
              OperationError<BatchUpdateServiceTypeTemplatesError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              BatchUpdateServiceTypeTemplatesSchema,
              BatchUpdateServiceTypeTemplatesBody,
              BatchUpdateServiceTypeTemplatesData,
              BatchUpdateServiceTypeTemplatesParameters,
              OperationError<BatchUpdateServiceTypeTemplatesError>,
              TContext
            >
      ): Array<
        Mutation<
          BatchUpdateServiceTypeTemplatesData,
          BatchUpdateServiceTypeTemplatesError,
          MutationVariables<BatchUpdateServiceTypeTemplatesBody, BatchUpdateServiceTypeTemplatesParameters>,
          TContext
        >
      >;
    };
    schema: BatchUpdateServiceTypeTemplatesSchema;
    types: {
      parameters: BatchUpdateServiceTypeTemplatesParameters;
      data: BatchUpdateServiceTypeTemplatesData;
      error: BatchUpdateServiceTypeTemplatesError;
      body: BatchUpdateServiceTypeTemplatesBody;
    };
  };
}
/**
 * @summary Get All
 * @description Gets all service type templates for the current office.
 */
export const getAllServiceTypeTemplatesGet = {
  schema: {
    method: 'get',
    url: '/service_type_templates',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetAllServiceTypeTemplatesGetSchema;
  [QraftServiceOperationsToken]: ServiceTypeTemplatesService['getAllServiceTypeTemplatesGet'];
};
/**
 * @summary Create
 * @description Creates a new service type template.
 */
export const createServiceTypeTemplatesPost = {
  schema: {
    method: 'post',
    url: '/service_type_templates',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateServiceTypeTemplatesPostSchema;
  [QraftServiceOperationsToken]: ServiceTypeTemplatesService['createServiceTypeTemplatesPost'];
};
/**
 * @summary Get
 * @description Gets a service type template by ID.
 */
export const getServiceTypeTemplatesTemplateIdGet = {
  schema: {
    method: 'get',
    url: '/service_type_templates/{template_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetServiceTypeTemplatesTemplateIdGetSchema;
  [QraftServiceOperationsToken]: ServiceTypeTemplatesService['getServiceTypeTemplatesTemplateIdGet'];
};
/**
 * @summary Update
 * @description Updates an existing service type template.
 */
export const updateServiceTypeTemplatesTemplateIdPatch = {
  schema: {
    method: 'patch',
    url: '/service_type_templates/{template_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateServiceTypeTemplatesTemplateIdPatchSchema;
  [QraftServiceOperationsToken]: ServiceTypeTemplatesService['updateServiceTypeTemplatesTemplateIdPatch'];
};
/**
 * @summary Batch Update Service Type Templates
 * @description Batch updates multiple service type templates.
 */
export const batchUpdateServiceTypeTemplates = {
  schema: {
    method: 'post',
    url: '/service_type_templates/batch/update',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: BatchUpdateServiceTypeTemplatesSchema;
  [QraftServiceOperationsToken]: ServiceTypeTemplatesService['batchUpdateServiceTypeTemplates'];
};
export const serviceTypeTemplatesService = {
  getAllServiceTypeTemplatesGet,
  createServiceTypeTemplatesPost,
  getServiceTypeTemplatesTemplateIdGet,
  updateServiceTypeTemplatesTemplateIdPatch,
  batchUpdateServiceTypeTemplates,
} as const;
type GetAllServiceTypeTemplatesGetSchema = {
  method: 'get';
  url: '/service_type_templates';
  security: ['HTTPBearer'];
};
type GetAllServiceTypeTemplatesGetParameters = undefined;
type GetAllServiceTypeTemplatesGetData =
  paths['/service_type_templates']['get']['responses']['200']['content']['application/json'];
type GetAllServiceTypeTemplatesGetError = unknown;
type CreateServiceTypeTemplatesPostSchema = {
  method: 'post';
  url: '/service_type_templates';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateServiceTypeTemplatesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateServiceTypeTemplatesPostData =
  paths['/service_type_templates']['post']['responses']['201']['content']['application/json'];
type CreateServiceTypeTemplatesPostError =
  paths['/service_type_templates']['post']['responses']['422']['content']['application/json'];
type CreateServiceTypeTemplatesPostBody =
  paths['/service_type_templates']['post']['requestBody']['content']['application/json'];
type GetServiceTypeTemplatesTemplateIdGetSchema = {
  method: 'get';
  url: '/service_type_templates/{template_id}';
  security: ['HTTPBearer'];
};
type GetServiceTypeTemplatesTemplateIdGetParameters =
  paths['/service_type_templates/{template_id}']['get']['parameters'];
type GetServiceTypeTemplatesTemplateIdGetData =
  paths['/service_type_templates/{template_id}']['get']['responses']['200']['content']['application/json'];
type GetServiceTypeTemplatesTemplateIdGetError =
  paths['/service_type_templates/{template_id}']['get']['responses']['422']['content']['application/json'];
type UpdateServiceTypeTemplatesTemplateIdPatchSchema = {
  method: 'patch';
  url: '/service_type_templates/{template_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateServiceTypeTemplatesTemplateIdPatchParameters =
  paths['/service_type_templates/{template_id}']['patch']['parameters'];
type UpdateServiceTypeTemplatesTemplateIdPatchData =
  paths['/service_type_templates/{template_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateServiceTypeTemplatesTemplateIdPatchError =
  paths['/service_type_templates/{template_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateServiceTypeTemplatesTemplateIdPatchBody =
  paths['/service_type_templates/{template_id}']['patch']['requestBody']['content']['application/json'];
type BatchUpdateServiceTypeTemplatesSchema = {
  method: 'post';
  url: '/service_type_templates/batch/update';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type BatchUpdateServiceTypeTemplatesParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type BatchUpdateServiceTypeTemplatesData =
  paths['/service_type_templates/batch/update']['post']['responses']['200']['content']['application/json'];
type BatchUpdateServiceTypeTemplatesError =
  paths['/service_type_templates/batch/update']['post']['responses']['422']['content']['application/json'];
type BatchUpdateServiceTypeTemplatesBody =
  paths['/service_type_templates/batch/update']['post']['requestBody']['content']['application/json'];
